import { useEffect, useState } from "react";
import { shareUrl } from "@/lib/adminApi";

// Copies a share link that unfurls with the painting's own preview image.
export default function ShareButton({ slug, title, url: customUrl, className = "detail-share", testId = "detail-share" }) {
  const [copied, setCopied] = useState(false);
  const url = customUrl || shareUrl(slug);

  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 2400);
    return () => clearTimeout(t);
  }, [copied]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setCopied(true);
  };

  return (
    <button
      type="button"
      className={`${className} mono-caps${copied ? " is-copied" : ""}`}
      onClick={copy}
      aria-label={`Copy link to ${title}`}
      data-cursor="Copy"
      data-testid={testId}
    >
      {copied ? "Link copied" : "Share — copy link"}
    </button>
  );
}
